import palette from "../palette";

export default {
    root: { 
        '&.MuiList-padding': {
          paddingTop: '0px',
          paddingBottom: '0px', 
          border: `1px solid ${palette.text.switchDisabled}`,
          borderRadius: '12px !important'
        },
    },
}